import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  GridItem,
  Input,
  Button,
  RadioGroup,
  RadioButton
} from "@sainsburys-tech/fable";
import { Add } from '@sainsburys-tech/icons'
import { FieldArray } from "formik";
import BehindFeatureFlag from "../BehindFeatureFlag/index.js";
import * as features from "../../utils/features";

const CbusZoneFormSection = props => {
  return (
    <React.Fragment>
      <section>
        <fieldset>
          <legend style={{ fontSize: '1rem', fontWeight: '600' }}>Is there a lux sensor?</legend>
          <RadioGroup
            name="hasLuxSensor"
            value={props.form.values.hasLuxSensor}
            onChange={e => {
              props.form.handleChange(e);
              if (e.target.value === "false") {
                props.form.values.luxSensorId = "";
                props.form.setFieldTouched("luxSensorId", false);
              }
            }}
            onBlur={props.form.handleBlur}
            status={props.form.touched.hasLuxSensor && props.form.errors.hasLuxSensor ? "error" : undefined}
          >
            <RadioButton value="true" label="Yes" />
            <RadioButton value="false" label="No" />
          </RadioGroup>
        </fieldset>
        {props.form.values.hasLuxSensor === "true" && (
          <Grid cols={{ xl: 4, lg: 3, md: 5, sm: 2, xs: 1 }}>
            <GridItem colSpan={{ xl: 1, lg: 1, md: 2, sm: 1, xs: 1 }}>
              <Input
                name={"luxSensorId"}
                label="Assign Lux Sensor ID"
                placeholder="Enter sensor ID number"
                status={
                  props.form.touched.luxSensorId &&
                  props.form.errors.luxSensorId ? "error" : undefined
                }
                supportingText={
                  props.form.touched.luxSensorId &&
                  props.form.errors.luxSensorId
                }
                value={props.form.values.luxSensorId}
                onBlur={props.form.handleBlur}
                onChange={props.form.handleChange}
              />
            </GridItem>
          </Grid>
        )}
      </section>

      <BehindFeatureFlag feature={features.PIR_ID}>
        <section>
          <Grid cols={{ xl: 2, lg: 3, md: 5, sm: 1, xs: 1 }}>
            <GridItem colSpan={{ xl: 1, lg: 2, md: 4, sm: 1, xs: 1 }}>
              <h3 className="fable:mb-4">Assign PIR sensor</h3>
              <p>
                Assign a PIR to the zone. If there is no PIR related to the
                zone, then leave this field empty.
              </p>
            </GridItem>
          </Grid>

          <FieldArray
            name="pirSensor"
            render={arrayHelpers => (
              <div>
                <Grid cols={{ xl: 4, lg: 3, md: 5, sm: 2, xs: 1 }} gap="md">
                  {props.form.values.pirSensor.map((pirSensor, index) => (
                    <GridItem
                      colSpan={{ xl: 1, lg: 1, md: 2, sm: 1, xs: 1 }}
                      key={index}
                      id={`pirSensor${index}`}
                    >
                      <Input
                        name={`pirSensor[${index}]`}
                        label="Assign PIR sensor"
                        placeholder="Enter PIR sensor ID number"
                        status={
                          props.form.touched.pirSensor !== undefined &&
                          typeof props.form.touched.pirSensor[index] !==
                            undefined &&
                          props.form.errors.pirSensor !== undefined &&
                          props.form.errors.pirSensor[index] !== undefined
                            ? "error"
                            : undefined
                        }
                        supportingText={
                          props.form.touched.pirSensor !== undefined &&
                          typeof props.form.touched.pirSensor[index] !==
                            undefined &&
                          props.form.errors.pirSensor !== undefined &&
                          props.form.errors.pirSensor[index] !== undefined
                            ? props.form.errors.pirSensor[index].value
                            : ""
                        }
                        value={
                          pirSensor.value ? pirSensor.value.toString() : ""
                        }
                        onBlur={props.form.handleBlur}
                        onChange={e => {
                          props.form.values.pirSensor[index].value =
                            e.target.value;
                          props.form.setFieldTouched(`pirSensor[${index}]`, [
                            true
                          ]);
                        }}
                      />
                    </GridItem>
                  ))}
                </Grid>
                <Button
                  variant="secondary"
                  onClick={() => {
                    arrayHelpers.push({
                      name: "pir",
                      value: null
                    });
                  }}
                >
                  <Add />
                  Add additional PIR zone
                </Button>
              </div>
            )}
          />
        </section>
      </BehindFeatureFlag>

      <section>
        <Grid cols={{ xl: 2, lg: 3, md: 5, sm: 1, xs: 1 }}>
          <GridItem colSpan={{ xl: 1, lg: 2, md: 4, sm: 1, xs: 1 }}>
            <h3 className="fable:mb-4">Assign C-Bus Group</h3>
            <p>
              Assign the unique C-Bus Group number to the lighting zone to map
              the lighting zone to the gateway.
            </p>
          </GridItem>
        </Grid>

        <Grid cols={{ xl: 4, lg: 3, md: 5, sm: 2, xs: 1 }}>
          <GridItem colSpan={{ xl: 1, lg: 1, md: 2, sm: 1, xs: 1 }}>
            <Input
              name={"cbusGroupId"}
              label="Assign C-Bus Group"
              placeholder="Enter C-BUS group number"
              status={
                props.form.touched.cbusGroupId && props.form.errors.cbusGroupId ? "error" : undefined
              }
              supportingText={
                props.form.touched.cbusGroupId && props.form.errors.cbusGroupId
              }
              value={props.form.values.cbusGroupId}
              onBlur={props.form.handleBlur}
              onChange={props.form.handleChange}
            />
          </GridItem>
        </Grid>
      </section>
    </React.Fragment>
  );
};

CbusZoneFormSection.propTypes = {
  form: PropTypes.object
};

export default CbusZoneFormSection;
